import { colors } from '@omilia/theme';
import { MessageStatus } from 'types';

export const useFilePreview = (
  errorMessage?: string,
  status?: MessageStatus,
) => {
  const isBackendFileError = status === MessageStatus.ERROR;
  const isError = !!(errorMessage || isBackendFileError);

  const getCloseIconColor = () => {
    return errorMessage ? colors.COLOR_RED_800 : colors.COLOR_GREY_800;
  };

  return {
    isError,
    closeIconColor: getCloseIconColor(),
  };
};
